// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optionsContainer {
  display: flex;
  flex-direction: row;
}

.optionsH4 {
  font-size: 18px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  margin-top: 12px;
}

.optionsSerial {
  margin-right: 30px;
  margin-bottom: 20px;
  margin-top: 10px;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  width: 10px;
}

.optionsCheck {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-right: 0;
  color: #fff;
  background-color: #449d44;
  border: 1px solid #398439;
  display: inline-block;
  padding: 5px 10px;
  vertical-align: middle;
  cursor: pointer;
}

.checkbox-label {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
  display: block;
  position: relative;
  left: 70px;
  margin: auto;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  height: 28px;
  width: 4px;
  clear: both;
  font-weight: normal;
  font-family: "Ruda", sans-serif;
  padding-right: 55px;
  margin-right: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-top: 4px;
  padding-left: 18px;
  border: 1px solid #adadad;
}

.checkbox-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label .mark {
  top: -1px;
  left: -36px;
  position: absolute;
  height: 34px;
  width: 44px;
  background-color: #449d44;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transition: all 0.3s ease-in;
}
.checkbox-label input:checked ~ .mark {
  background-color: #449d44;
  transform: rotate(0deg) scale(1);
  opacity: 1;
}
.checkbox-label .mark::after {
  position: absolute;
  content: "";
  border-radius: 5px;
}
.checkbox-label input:checked ~ .mark::after {
  transform: rotate(45deg) scale(1);
  left: 17px;
  top: 4px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 4px 4px 0;
  border-radius: 0;
}

.checkbox-label1 {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
  display: block;
  position: relative;
  left: 155px;
  margin: auto;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  height: 28px;
  width: 85px;
  clear: both;
  font-weight: normal;
  font-family: "Ruda", sans-serif;
  padding-right: 6px;
  margin-right: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-top: 4px;
  padding-left: 18px;
  border: 1px solid #adadad;
}

.checkbox-label1 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label1 .mark1 {
  top: -1px;
  left: -36px;
  position: absolute;
  height: 34px;
  width: 44px;
  background-color: #5bc0de;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transition: all 0.3s ease-in;
}
.checkbox-label1 input:checked ~ .mark1 {
  background-color: #5bc0de;
  transform: rotate(0deg) scale(1);
  opacity: 1;
}
.checkbox-label1 .mark1::after {
  position: absolute;
  content: "";
  border-radius: 5px;
}
.checkbox-label1 input:checked ~ .mark1::after {
  transform: rotate(45deg) scale(1);
  left: 17px;
  top: 4px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 4px 4px 0;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/Options/options.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".optionsContainer {\n  display: flex;\n  flex-direction: row;\n}\n\n.optionsH4 {\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  margin-top: 12px;\n}\n\n.optionsSerial {\n  margin-right: 30px;\n  margin-bottom: 20px;\n  margin-top: 10px;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  width: 10px;\n}\n\n.optionsCheck {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  margin-right: 0;\n  color: #fff;\n  background-color: #449d44;\n  border: 1px solid #398439;\n  display: inline-block;\n  padding: 5px 10px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n  display: block;\n  position: relative;\n  left: 70px;\n  margin: auto;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 24px;\n  height: 28px;\n  width: 4px;\n  clear: both;\n  font-weight: normal;\n  font-family: \"Ruda\", sans-serif;\n  padding-right: 55px;\n  margin-right: 40px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding-top: 4px;\n  padding-left: 18px;\n  border: 1px solid #adadad;\n}\n\n.checkbox-label input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkbox-label .mark {\n  top: -1px;\n  left: -36px;\n  position: absolute;\n  height: 34px;\n  width: 44px;\n  background-color: #449d44;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  transition: all 0.3s ease-in;\n}\n.checkbox-label input:checked ~ .mark {\n  background-color: #449d44;\n  transform: rotate(0deg) scale(1);\n  opacity: 1;\n}\n.checkbox-label .mark::after {\n  position: absolute;\n  content: \"\";\n  border-radius: 5px;\n}\n.checkbox-label input:checked ~ .mark::after {\n  transform: rotate(45deg) scale(1);\n  left: 17px;\n  top: 4px;\n  width: 8px;\n  height: 16px;\n  border: solid white;\n  border-width: 0 4px 4px 0;\n  border-radius: 0;\n}\n\n.checkbox-label1 {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n  display: block;\n  position: relative;\n  left: 155px;\n  margin: auto;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 24px;\n  height: 28px;\n  width: 85px;\n  clear: both;\n  font-weight: normal;\n  font-family: \"Ruda\", sans-serif;\n  padding-right: 6px;\n  margin-right: 40px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding-top: 4px;\n  padding-left: 18px;\n  border: 1px solid #adadad;\n}\n\n.checkbox-label1 input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkbox-label1 .mark1 {\n  top: -1px;\n  left: -36px;\n  position: absolute;\n  height: 34px;\n  width: 44px;\n  background-color: #5bc0de;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  transition: all 0.3s ease-in;\n}\n.checkbox-label1 input:checked ~ .mark1 {\n  background-color: #5bc0de;\n  transform: rotate(0deg) scale(1);\n  opacity: 1;\n}\n.checkbox-label1 .mark1::after {\n  position: absolute;\n  content: \"\";\n  border-radius: 5px;\n}\n.checkbox-label1 input:checked ~ .mark1::after {\n  transform: rotate(45deg) scale(1);\n  left: 17px;\n  top: 4px;\n  width: 8px;\n  height: 16px;\n  border: solid white;\n  border-width: 0 4px 4px 0;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
